export const staleTime = 0;
